import React, { useState } from 'react';
import Button from './ui/Button';
import { Spinner } from './ui/Spinner';
import { sendOAuthRequest } from '../utils/AuthService';
import { useTranslation } from 'react-i18next';
import Logo from '../assets/images/logo.png';

const LandingPage = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);

    const handleLogin = () => {
        if (loading) return;
        setLoading(true);
        // sendOAuthRequest likely performs a redirect; loading state prevents double click
        try {
            sendOAuthRequest();
        } finally {
            // If redirect doesn't happen (e.g., error), re-enable after short delay
            setTimeout(() => setLoading(false), 4000);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card" role="main" aria-labelledby="landing-auth-title">
                <div className="auth-form-section">
                    <img src={Logo} alt="Mowazaf Logo" className="auth-logo" loading="lazy" />
                    <h1 id="landing-auth-title" className="auth-title">{t('Welcome to Mowazaf')}</h1>
                    <p className="auth-subtitle">{t('Please sign in to access your account')}</p>
                    <Button
                        variant="default"
                        onClick={handleLogin}
                        disabled={loading}
                        className="auth-btn w-full"
                        aria-label={t('Sign In') as string}
                    >
                        {loading ? (
                            <>
                                <Spinner size="sm" className="me-2" />
                                {t('Signing In')}...
                            </>
                        ) : (
                            t('Sign In')
                        )}
                    </Button>
                    <p className="auth-alt">
                        {t('New to Mowazaf?')}<a href="/signup">{t('Create a free workspace')}</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
